export default __webpack_public_path__ + "static/media/logo.465eae30.jpg";